import axios from "axios"

const endpoint =
  "https://dq8r3gzded.execute-api.ap-southeast-2.amazonaws.com/dev"

export const getToken = async () => {
  const response = await axios.get(endpoint + "/getToken")
  return response.data.body
}

export const getExcel = async () => {
  const response = await axios.get(endpoint + "/updateExcel")
  return response.data.body
}

export const updateExcel = async (body) => {
  await axios.put(endpoint + "/updateExcel", body)
}
